var currentRouteIdentifier = undefined;
var lastRecordedNavigationStartMarker = undefined;
export var fluidPerformanceMarker = new Map();
export var recordedMarkers = new Map();
export var recordedMeasures = new Set();
export function getCurrentRouteIdentifier() {
    return currentRouteIdentifier;
}
export function setCurrentRouteIdentifier(routeIdentifier) {
    currentRouteIdentifier = routeIdentifier;
}
export function getLastRecordedNavigationStartMarker() {
    return lastRecordedNavigationStartMarker;
}
export function setLastRecordedNavigationStartMarker(marker) {
    lastRecordedNavigationStartMarker = marker;
}
//# sourceMappingURL=PerformanceServiceStates.js.map